import userActions from './userActions'
import shipmentActions from './shipmentActions';
const allActions={
    userActions,
    shipmentActions
}

export default allActions;